import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';
import { RctCard, RctCardContent } from 'Components/RctCard';

import { 
   fetchORTIronReport,
   fetchORTDrivingReport,
   fetchORTLongGameReport,
   fetchORTChippingReport,
   fetchORTBunkerReport,
   fetchORTWedgeReport,
   fetchORTShortGameReport,
   fetchPlayerIntervention
 } from 'Actions';

import LongGame from './rangelonggame';
import ShortGame from './rangeshortgame';
import PuttGame from './puttingtest';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class GolfRangeTest extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
     
    }
    constructor(props) {
      
        super(props);
        let startDate = new Date();
        let befrstart=new Date(startDate.setMonth(startDate.getMonth() - 2));
        this.state = {  
            student:this.props.data.student, 
            startdate:'',
            enddate:'',
            loader:false,
            maindiv:true,
            longgame:false,
            shortgame:false,
            puttgame:false,
        };

        this.onBackSection = this.onBackSection.bind(this);
    }

    rangeSelection(id){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        var contact='';
        var area='';
        var shot='';
        var distance='';
       if(id==1){
            this.props.fetchORTLongGameReport(student, stdate, eddate, distance, shot, area, contact);
            this.props.fetchORTDrivingReport(student, stdate, eddate, distance, area, contact);
            this.props.fetchORTIronReport(student, stdate, eddate, distance, area, contact);
                this.setState({ 
                    maindiv:false,
                    shortgame:false,
                    puttgame:false,
                    longgame:true,
                });
        }else if(id==2){
            this.props.fetchORTShortGameReport(student, stdate, eddate, shot, area, contact);
            this.props.fetchORTChippingReport(student, stdate, eddate, shot, area, contact);
            this.props.fetchORTBunkerReport(student, stdate, eddate, area, contact);
            this.props.fetchORTWedgeReport(student, stdate, eddate, distance, area, contact);
                this.setState({ 
                    maindiv:false,
                    longgame:false,
                    puttgame:false,
                    shortgame:true,
                });
        }else if(id==3){
           
                this.setState({ 
                    maindiv:false,
                    longgame:false,
                    shortgame:false,
                    puttgame:true,
                });
        }
    }

    onBackSection() {
        var student=this.state.student;
        var stdate='';
        var eddate='';
        this.props.fetchPlayerIntervention(student, stdate, eddate).then((data) => {  
            this.setState({ 
                startdate:stdate,
                enddate:eddate,
                maindiv:true,
                longgame:false,
                shortgame:false,
            });
        });
	}


render() {

    const { playerinterventionlist, loading} = this.props;   
    

      return(
        <div>   
                {this.state.maindiv && 
                <>
                <div className="row" style={{marginBottom:"20px"}}>
                    <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                    <div className="col-lg-8"><h2 className="text-center">ON RANGE TESTS</h2></div>
                    <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.props.onClick1(1)}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                </div>
                <div className="row" style={{display:"flex",justifyContent: "center"}}>
                    
                <div className="col-sm-12 col-lg-3 custom-class">
                        <RctCard>
                            <a onClick={() =>this.rangeSelection(1)}>
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/rng_longgame.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">ON RANGE LONG GAME</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.onrangetest.longgametot}</strong></div>
                              </RctCardContent>
                            </a>  
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3 custom-class">
                        <RctCard>
                            <a onClick={() =>this.rangeSelection(2)}>
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/rng_shortgame.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">ON RANGE SHORT GAME RANDOM</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.onrangetest.shortgametot}</strong></div>
                              </RctCardContent>
                            </a>  
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3 custom-class">
                        <RctCard>
                            <a onClick={() =>this.rangeSelection(3)}>
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/rng_putting.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">ON RANGE PUTTING</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.onrangetest.putttot}</strong></div>
                              </RctCardContent>
                            </a>  
                        </RctCard>      
                     </div>     
                    
                </div>  
            </>        
            } 
            
            {this.state.longgame &&
               <LongGame onClick={() => this.props.onClick()} onClick1={this.onBackSection} data={this.state}/>
            }

            {this.state.shortgame &&
               <ShortGame onClick={() => this.props.onClick()} onClick1={this.onBackSection} data={this.state}/>
            }

            {this.state.puttgame&&
               <PuttGame onClick={() => this.props.onClick()} onClick1={this.onBackSection} data={this.state}/>
            }

        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention }) => {
    const { playerinterventionlist, loading } = playerintervention;
    return { playerinterventionlist, loading };
   
}


export default connect(mapStateToProps, {
    fetchORTIronReport,
   fetchORTDrivingReport,
   fetchORTLongGameReport,
   fetchORTChippingReport,
   fetchORTBunkerReport,
   fetchORTWedgeReport,
   fetchORTShortGameReport,
   fetchPlayerIntervention
})(GolfRangeTest);
